import React, { useEffect, useState, Suspense } from 'react';
import RiseLoader from 'react-spinners/RiseLoader';
import MainRoute from './routes';
// page
import Maintenance from 'pages/maintenance';
//context
import UserContextProvider from 'context/userContext';
import { GlobalContextProvider } from 'context/globalContext';
import { useCompanyStore } from 'stores';
import { getSettingCompany } from 'api/company';
import setCSSVariables from 'utils/setTheme';
//styles
import 'assets/css/styles.scss';

export function Welcome() {
  return (
    <div className="App">
      <GlobalContextProvider>
        <UserContextProvider>
          <MainRoute />
        </UserContextProvider>
      </GlobalContextProvider>
    </div>
  );
}

function App() {
  const [inMaintenance, setInMaintenance] = useState(false);
  const theme = useCompanyStore((state) => state.theme);

  useEffect(() => {
    setCSSVariables(theme);
    const handleSetting = async () => {
      const { data, status } = await getSettingCompany();
      if (status === 200 && data?.results?.length > 0) {
        setInMaintenance(data.results[0].maintenance_mode);
      }
    };
    handleSetting();
  }, [theme]);

  return (
    <Suspense
      fallback={
        <div className="spinner-container">
          <RiseLoader color="var(--primary-color)" size={25} />
        </div>
      }
    >
      {inMaintenance ? <Maintenance /> : <Welcome />}
    </Suspense>
  );
}

export default App;
